const handleWrapHalfImage = () => {
	$('[alt*="|| half-image"]').each(function(index, el) {
		const $this = $(this);
		const altText = $this.attr('alt').replace('|| half-image', '');

		$this.wrapAll('<div class="half-image"></div>');

		$('<p></p>').text(altText).appendTo($this.closest('.half-image'));

		$this.attr('alt', altText);
	});
}

handleWrapHalfImage();
